/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc pc端商品分类搜索查询
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.CommodityPcCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.CommodityDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/commodities/search-pc`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
